import Mapcofig from './config/Mapcofig';
import MapcofigHLW2D from './config/MapcofigHLW2D';
import MapcofigHLW2DKEY from './config/MapcofigHLW2DKEY';
import MapcofigZWW2D from './config/MapcofigZWW2D';
import MapcofigJYW3D from './config/MapcofigJYW3D';
import MapcofigZWW3D from './config/MapcofigZWW3D';
import MapcofigZWW3DNJDL from './config/MapcofigZWW3DNJDL';
import MapcofigXZK from './config/MapcofigXZK';
var Network = /** @class */ (function () {
    function Network() {
    }
    Network.prototype.setNet = function (network) {
        switch (network) {
            case 'internet':
                Mapcofig.jsapi = MapcofigHLW2DKEY.jsapi;
                Mapcofig.jsapiversion4X = MapcofigHLW2DKEY.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigHLW2DKEY.tokenserver;
                Mapcofig.proxyURL = MapcofigHLW2DKEY.proxyURL;
                Mapcofig.proxyConifg = MapcofigHLW2DKEY.proxyConifg;
                Mapcofig.fonts = MapcofigHLW2DKEY.fonts;
                Mapcofig.gisService = MapcofigHLW2DKEY.gisService;
                Network.needKey = true;
                Network.keyURL = "http://www.962121.net/hmfmstest/gisshare/service/gisauth/api/v1/configInfo/appKey";
                break;
            case 'smitest':
                Mapcofig.jsapi = MapcofigHLW2D.jsapi;
                Mapcofig.jsapiversion4X = MapcofigHLW2D.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigHLW2D.tokenserver;
                Mapcofig.proxyURL = MapcofigHLW2D.proxyURL;
                Mapcofig.proxyConifg = MapcofigHLW2D.proxyConifg;
                Mapcofig.fonts = MapcofigHLW2D.fonts;
                Mapcofig.gisService = MapcofigHLW2D.gisService;
                Network.needKey = false;
                break;
            case 'xzk':
                Mapcofig.jsapi = MapcofigXZK.jsapi;
                Mapcofig.jsapiversion4X = MapcofigXZK.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigXZK.tokenserver;
                Mapcofig.proxyURL = MapcofigXZK.proxyURL;
                Mapcofig.proxyConifg = MapcofigXZK.proxyConifg;
                Mapcofig.fonts = MapcofigXZK.fonts;
                Mapcofig.gisService = MapcofigXZK.gisService;
                Network.needKey = false;
                break;
            case 'affairs':
                Mapcofig.jsapi = MapcofigZWW2D.jsapi;
                Mapcofig.jsapiversion4X = MapcofigZWW2D.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigZWW2D.tokenserver;
                Mapcofig.proxyURL = MapcofigZWW2D.proxyURL;
                Mapcofig.proxyConifg = MapcofigZWW2D.proxyConifg;
                Mapcofig.fonts = MapcofigZWW2D.fonts;
                Mapcofig.gisService = MapcofigZWW2D.gisService;
                Network.needKey = true;
                Network.keyURL = "http://10.81.71.243:23456/hmfmstest/gisshare/service/gisauth/api/v1/configInfo/appKey";
                break;
            // case 'local':
            //     Mapcofig.jsapi = .jsapi;
            //     Mapcofig.jsapiversion4X = .jsapiversion4X;
            //     Mapcofig.tokenserver = .tokenserver;
            //     Mapcofig.proxyURL = .proxyURL;
            //     Mapcofig.proxyConifg = .proxyConifg;
            //     Mapcofig.fonts = .fonts;
            //     Mapcofig.gisService = .gisService;
            //     break;
            case 'local3D':
                Mapcofig.jsapi = MapcofigJYW3D.jsapi;
                Mapcofig.jsapiversion4X = MapcofigJYW3D.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigJYW3D.tokenserver;
                Mapcofig.proxyURL = MapcofigJYW3D.proxyURL;
                Mapcofig.proxyConifg = MapcofigJYW3D.proxyConifg;
                Mapcofig.fonts = MapcofigJYW3D.fonts;
                Mapcofig.gisService = MapcofigJYW3D.gisService;
                Network.needKey = false;
                break;
            case 'affairs3D':
                Mapcofig.jsapi = MapcofigZWW3D.jsapi;
                Mapcofig.jsapiversion4X = MapcofigZWW3D.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigZWW3D.tokenserver;
                Mapcofig.proxyURL = MapcofigZWW3D.proxyURL;
                Mapcofig.proxyConifg = MapcofigZWW3D.proxyConifg;
                Mapcofig.fonts = MapcofigZWW3D.fonts;
                Mapcofig.gisService = MapcofigZWW3D.gisService;
                Network.needKey = false;
                break;
            case 'njdl':
                Mapcofig.jsapi = MapcofigZWW3DNJDL.jsapi;
                Mapcofig.jsapiversion4X = MapcofigZWW3DNJDL.jsapiversion4X;
                Mapcofig.tokenserver = MapcofigZWW3DNJDL.tokenserver;
                Mapcofig.proxyURL = MapcofigZWW3DNJDL.proxyURL;
                Mapcofig.proxyConifg = MapcofigZWW3DNJDL.proxyConifg;
                Mapcofig.fonts = MapcofigZWW3DNJDL.fonts;
                Mapcofig.gisService = MapcofigZWW3DNJDL.gisService;
                Network.needKey = false;
                break;
        }
    };
    Network.needKey = true;
    Network.keyURL = "";
    Network.appKey = "";
    return Network;
}());
export default Network;
